import React from "react";
import Image from "next/image";
import Tiktok from "@/app/assets/tiktok-logo.png";
import Youtube from "@/app/assets/youtube-logo.png";
import Facebook from "@/app/assets/facebook-logo.png";
import XLogo from "@/app/assets/x-logo.png";
import Linkedin from "@/app/assets/linkedin-logo.png";
import Instagram from "@/app/assets/ig-logo.png";

export default function SocialIcons({ data }: { data?: any }) {
    let imgSrc: any;

    return (
        <div className="flex items-center gap-x-4">
            {data?.map((icons: any, index: number) => {
                switch (icons.name) {
                    case "tiktok":
                        imgSrc = Tiktok;
                        break;
                    case "instagram":
                        imgSrc = Instagram;
                        break;
                    case "linkedin":
                        imgSrc = Linkedin;
                        break;
                    case "facebook":
                        imgSrc = Facebook;
                        break;
                    case "youtube":
                        imgSrc = Youtube;
                        break;
                    case "x":
                        imgSrc = XLogo;
                        break;
                    default:
                        break;
                }

                return (
                    <a
                        key={index}
                        href={`${
                            icons.redirectLink ? icons.redirectLink : "/"
                        }`}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Visit Kingdom Digital on ${icons.name}`}
                        className="flex w-6  h-auto aspect-square socials-icons"
                        data-social={icons.name}
                    >
                        <Image
                            src={imgSrc}
                            width={80}
                            height={80}
                            alt=""
                            className=" w-full h-full object-contain"
                            loading="lazy"
                            // add data attribute data-social
                        />
                    </a>
                );
            })}
        </div>
    );
}
